import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useBlocker } from "./useBlocker";

export function useCallbackPrompt(showWhen: boolean) {
  const navigate = useNavigate();
  const location = useLocation();
  const [showPrompt, setShowPrompt] = useState(false);
  const [lastLocation, setLastLocation] = useState<any>(null);
  const [confirmedNavigation, setConfirmedNavigation] = useState(false);
  const [disablePrompt, setDisablePrompt] = useState<boolean>(false);

  const cancelNavigation = useCallback(() => {
    setShowPrompt(false);
  }, []);

  const handleBlockedNavigation = useCallback(
    (nextLocation: any) => {
      if (
        nextLocation.location.pathname == "/login" ||
        /\/home\/forms\/[^/]+\/form-entry/.test(nextLocation.location.pathname)
      ) {
        setLastLocation(nextLocation);
        setConfirmedNavigation(true);
        return true;
      }

      if (
        !confirmedNavigation &&
        nextLocation.location.pathname !== location.pathname
      ) {
        setShowPrompt(true);
        setLastLocation(nextLocation);
        return false;
      }

      return true;
    },
    [confirmedNavigation]
  );

  const confirmNavigation = useCallback(() => {
    setShowPrompt(false);
    setConfirmedNavigation(true);
  }, []);

  useEffect(() => {
    if (confirmedNavigation && lastLocation) {
      navigate(lastLocation.location.pathname);
      setConfirmedNavigation(false);
    }
  }, [confirmedNavigation, lastLocation]);

  useBlocker(handleBlockedNavigation, showWhen && !disablePrompt);

  return [
    showPrompt,
    confirmNavigation,
    cancelNavigation,
    setDisablePrompt,
  ] as const;
}
